import { progressNotification } from "../../ui";
import { ApiListItem } from "../../model";
import { DataMapper } from "./DataMapper";
import { Exportable } from "./Exportable";
import { Translations } from "../Translations";

/** Methods for importing data into Salaxy system. */
export class ExportLogic {
  /**
   * Gets the export data and does the mapping potentially asynchronously and emitting notifications to the user interface.
   * NOTE: This method is for EXPORT functionality. If there are more methods like this, create a separate ExportHelpers.
   * @param exportApi The API that implements the Exportable interface: Fetching of the data.
   * @param mapper The preloaded mapper that is selected and resoplved.
   * @param maxCount Maximum count of items. null/0 for all items.
   * @param notify Optional progress notification function
   * @returns Result DataRows as mapped.
   */
  public static getExportData(exportApi: Exportable<any>, mapper: DataMapper<any, any>, maxCount?: number, notify: progressNotification<void> | undefined = undefined): Promise<any[]> {
    if (mapper.isSourceAList) {
      // The list is what it is => No need to query items separately
      return exportApi.list(maxCount, notify).then((items) => {
        return mapper.doMap(items);
      });
    } else {

      // We are querying the payload items from API one-by-one.

      const getRows: (items: ApiListItem[], notify?: progressNotification<void>) => Promise<any[]>
        = (items, notify) => {
          const rows: any[] = [];
          let index = 0;
          const next = (): Promise<void> => {
            if (index === items.length) {
              return Promise.resolve();
            }
            return exportApi.getSingle(items[index])
              .then((apiResult) => {
                rows.push(...mapper.doMap([apiResult]));
                if (notify) {
                  notify(Translations.get("SALAXY.NG1.ExportComponent.creatingRows"), index, items.length);
                }
                index++;
                return next();
              });
          };
          return next().then(() => {
            return rows;
          });
        };

      return exportApi.list(maxCount, notify).then((items) => {
        return getRows(items, notify).then((rows) => {
          // this extra resolve is required for the post copy -paste call to succeed in NG1 library.
          return Promise.resolve(rows);
        });
      });
    }

  }

}
